export type ServiceItem = {
  key: string
  title: string
  description: string
  image: string
  href?: string
  buttonText?: string
  // optional English/localized fields
  title_en?: string
  description_en?: string
  buttonText_en?: string
  title_fr?: string
  description_fr?: string
  buttonText_fr?: string
}

export const servicesTravel: ServiceItem[] = [
  {
    key: "idiomas",
    title: "Idiomas",
    description:
      "Cursos intensivos para aprender un idioma en destinos donde se habla de forma nativa.",
    image: "https://drive.google.com/uc?export=view&id=1mz84si-5sR0iPOE-0qpPqSjqqL8EYOJI",
    href: "/servicios/idiomas",
    buttonText: "Ver más",
    title_en: "Languages",
    description_en: "Intensive courses to learn a language in destinations where it is natively spoken.",
    buttonText_en: "See more",
    title_fr: "Langues",
    description_fr: "Cours intensifs pour apprendre une langue dans des destinations où elle est parlée nativement.",
    buttonText_fr: "Voir plus",
  },
  {
    key: "work-and-study",
    title: "Estudia y trabaja",
    description:
      "Programas que combinan estudios con experiencia laboral en el extranjero.",
    image: "https://drive.google.com/uc?export=view&id=1vgCBhaTpCRi8PZ6Rf0GqaJh35Txo9H0d",
    href: "/servicios/estudia-y-trabaja",
    buttonText: "Ver más",
    title_en: "Study & Work",
    description_en: "Programs that combine studies with work experience abroad.",
    buttonText_en: "See more",
    title_fr: "Étudier et travailler",
    description_fr: "Programmes qui combinent des études avec une expérience professionnelle à l'étranger.",
    buttonText_fr: "Voir plus",
  },
  {
    key: "highschool",
    title: "High School",
    description:
      "Programas diseñados para preparar académica y lingüísticamente a alumnos en el extranjero.",
    image: "https://drive.google.com/uc?export=view&id=1mCUQvtk2hcCIbUGaVSPZMVOWhCTIEIik",
    href: "/servicios/highschool",
    buttonText: "Ver más",
    title_en: "High School",
    description_en: "Programs designed to prepare students academically and linguistically for studying abroad.",
    buttonText_en: "See more",
    title_fr: "High School",
    description_fr: "Programmes conçus pour préparer les élèves sur les plans académique et linguistique à étudier à l'étranger.",
    buttonText_fr: "Voir plus",
  },
  {
    key: "aupair",
    title: "Au Pair",
    description:
      "Vive con una familia anfitriona, cuida de sus hijos y enriquece tu experiencia cultural.",
  image: "https://drive.google.com/uc?export=view&id=1b_FG0FO4II1d6adAZ2Ayh_wPc94id7Yy",
    href: "/servicios/aupair",
    buttonText: "Ver más",
    title_en: "Au Pair",
    description_en: "Live with a host family, care for their children, and enrich your cultural experience.",
    buttonText_en: "See more",
    title_fr: "Au Pair",
    description_fr: "Vivez au sein d'une famille d'accueil, prenez soin de ses enfants et enrichissez votre expérience culturelle.",
    buttonText_fr: "Voir plus",
  },
  {
    key: "pathway",
    title: "Pathway",
    description:
      "Trayectorias académicas que te preparan para la educación superior.",
    image: "https://drive.google.com/uc?export=view&id=18MQnzkusRZ4fYhfJjD1_PIEVbwhtCkKA",
    href: "/servicios/pathway",
    buttonText: "Ver más",
    title_en: "Pathway",
    description_en: "Academic pathway programs that prepare you for higher education.",
    buttonText_en: "See more",
    title_fr: "Parcours préparatoire",
    description_fr: "Parcours académiques qui vous préparent à l'enseignement supérieur.",
    buttonText_fr: "Voir plus",
  },
  {
    key: "educacion-superior",
    title: "Educación Superior",
    description:
      "Licenciaturas, maestrías y doctorados en universidades de prestigio mundial.",
    image: "https://drive.google.com/uc?export=view&id=10OR4FL-I5sGb1RhxNwCCYApIT_R5qEGM",
    href: "/servicios/educacion-superior",
    buttonText: "Ver más",
    title_en: "Higher Education",
    description_en: "Undergraduate, master's and doctoral programs at world-renowned universities.",
    buttonText_en: "See more",
    title_fr: "Enseignement supérieur",
    description_fr: "Programmes de licence, de master et de doctorat dans des universités de renommée mondiale.",
    buttonText_fr: "Voir plus",
  },
  {
    key: "ingles-online",
    title: "Inglés online",
    description:
      "Aprende inglés desde cualquier lugar con clases en línea.",
    image: "/hero-images/ingles-online.jpg",
    href: "/servicios/ingles-online",
    buttonText: "Ver más",
    title_en: "Online English",
    description_en: "Learn English from anywhere with online classes.",
    buttonText_en: "See more",
    title_fr: "Anglais en ligne",
    description_fr: "Apprenez l'anglais depuis n'importe quel endroit grâce à des cours en ligne.",
    buttonText_fr: "Voir plus",
  },
  {
    key: "grupos-educativos",
    title: "Grupos educativos",
    description:
      "Programas y viajes académicos para grupos estudiantiles.",
    image: "https://drive.google.com/uc?export=view&id=1uhJDknWKJFA4Rp38CFAuzTCGUGXYL6l_",
    href: "/servicios/grupos-educativos",
    buttonText: "Ver más",
    title_en: "Educational Groups",
    description_en: "Academic programs and trips for student groups.",
    buttonText_en: "See more",
    title_fr: "Groupes éducatifs",
    description_fr: "Programmes académiques et voyages pour des groupes d'étudiants.",
    buttonText_fr: "Voir plus",
  },
]
